import { Button, Flex, TextInput, Title } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import React from 'react';

type TableHeaderProps = {
  title: string;
  buttonLabel: string;
  onButtonClick: () => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
};

const TableHeader: React.FC<TableHeaderProps> = ({
  title,
  buttonLabel,
  onButtonClick,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Buscar...',
}) => {
  return (
    <>
      <Title mb="xl">{title}</Title>
      <Flex mb="md">
        <Button onClick={onButtonClick} variant="filled">
          {buttonLabel}
        </Button>
        <TextInput
          placeholder={searchPlaceholder}
          icon={<IconSearch size="0.9rem" stroke={1.5} />}
          value={searchValue}
          onChange={(e) => onSearchChange(e.currentTarget.value)}
          ml="sm"
          sx={{ width: '100%', maxWidth: 350 }}
          variant="filled"
        />
      </Flex>
    </>
  );
};

export default TableHeader;
